import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useHandleRequestMutation } from "../../../redux/apiSlices/requestSlice";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function DecisionModal({
  showModal,
  title = "تأكيد",
  bodyText = "هل أنت متأكد من اتخاذ هذا القرار؟",
  handleCloseModal,
  decision,
  selectedRequest,
}) {
  const [note, setNote] = useState("");
  const [requestType, setRequestType] = useState('');
  const [approvedSoon, setApprovedSoon] = useState(false);
  const [approvedDate, setApprovedDate] = useState(new Date());

  const [handleRequest, { isLoading }] = useHandleRequestMutation();

  // console.log(new Date(approvedDate).toISOString())

  const handleRequestType = (event) => {
    setRequestType(event.target.value);
  }

  const handleConfirm = async (e) => {
    e.preventDefault();
    let decisionObj = {
      request_id: selectedRequest.id,
      decision,
      title:requestType,
      handler_notice: note,
      approved_date:
        approvedSoon && approvedDate
          ? new Date(approvedDate).toISOString()
          : "",
    };
    console.log(decisionObj);
    console.log(selectedRequest)
    try {
      await handleRequest(decisionObj).unwrap();
      handleCloseModal();
      setNote("");
    } catch (err) {
      console.error("Failed to save the changes", err);
    }
  };

  useEffect(()=>{
      setRequestType(selectedRequest?.title)
      console.log('reaquest type has been set')
  },[selectedRequest])

  return (
    <Modal show={showModal} onHide={handleCloseModal}>
      <Modal.Header className="bg-dark">
        <Modal.Title className="fs-5 text-white mb-0">{title}</Modal.Title>
        <Button
          variant="light"
          className="mb-0"
          size="sm"
          onClick={handleCloseModal}
          aria-label="Close"
        >
          <i class="bi bi-x-lg"></i>
        </Button>
      </Modal.Header>
      <Modal.Body>
        {bodyText}
        <Form>
          {decision === "secretary_rejected" && (
            <Form.Check
              className="mb-3 mt-5"
              type="switch"
              id="custom-switch"
              label="تمت الموافقة قريبا"
              checked={approvedSoon}
              onChange={(e) => setApprovedSoon(e.target.checked)}
            />
          )}
          {approvedSoon && (
            <Form.Group
              className="my-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>تاريخ آخر موافقة </Form.Label>

              <ReactDatePicker
                dateFormat="dd/MM/yyyy"
                selected={approvedDate}
                onChange={(date) => setApprovedDate(date)}
                className="border-0 bg-light rounded-end p-2 mx-2"
              />
            </Form.Group>
          )}
          <Form.Group className="my-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>نوع العريضة </Form.Label>
            <Form.Select value={requestType}  onChange={handleRequestType} aria-label="Default select example">
            <option value="مساعدة شخصية">مساعدة شخصية</option>
                      <option value="زواج">زواج</option>
                      <option value="علاج">علاج</option>
                      <option value="مصاريف دراسية">مصاريف دراسية</option>
                      <option value="أخرى">أخرى</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="my-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>ملاحظة </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="اكتب ملاحظاتك هنا"
              className="border-0 bg-light rounded-end px-2"
              name="note"
              onChange={(e) => setNote(e.target.value)}
              value={note}
              autoFocus
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="my-0"
          variant={
            decision === "secretary_accepted"
              ? "danger-soft"
              : "outline-primary"
          }
          onClick={handleCloseModal}
        >
          إلغاء
        </Button>
        {isLoading ? (
          <Button
            className="my-0"
            variant={
              decision === "secretary_accepted"
                ? "outline-primary"
                : "danger-soft"
            }
            disabled
          >
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            {" يتم التحميل..."}
          </Button>
        ) : (
          <Button
            className="my-0"
            variant={
              decision === "secretary_accepted"
                ? "outline-primary"
                : "danger-soft"
            }
            onClick={handleConfirm}
          >
            تأكيد
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default DecisionModal;
